import { useEffect, type ReactNode } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/providers/auth-provider';

const PROTECTED_PREFIXES = [
  '/dashboard',
  '/e-commerce',
  '/social-manager',
  '/settings',
  '/analytics',
  '/automation',
  '/customization',
];
const AUTH_ROUTES = ['/login', '/register', '/forgot-password', '/reset-password'];

export function AuthGuard({ children }: { children: ReactNode }) {
  const { session, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (loading) return;

    const pathname = location.pathname;
    const isProtected = PROTECTED_PREFIXES.some((prefix) => pathname.startsWith(prefix));
    const isAuthRoute = AUTH_ROUTES.some((route) => pathname.startsWith(route));

    if (isProtected && !session) {
      navigate('/login', { state: { redirect: pathname }, replace: true });
    } else if (isAuthRoute && session) {
      navigate('/dashboard', { replace: true });
    }
  }, [session, loading, location.pathname, navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  return <>{children}</>;
}
